import React from 'react';
import '../styles/components.css';

const Container = ({ children, className = '', maxWidth = true }) => {
  const containerClass = maxWidth ? 'container-custom' : '';
  return (
    <div className={`${containerClass} ${className}`.trim()}>
      {children}
    </div>
  );
};

export default Container;
